module.exports = "/images/logo-sobatppt-d7cc095a85e7ebd4cfae6173afdf19b1.png";